export default {"src":"/_next/static/media/redo.46cb17b5.svg","height":10,"width":18,"blurWidth":0,"blurHeight":0};